// extracted by mini-css-extract-plugin
export default {"levelText":"style_levelText__t69Km","levelUpText":"style_levelUpText__uDbZe","levelNumber":"style_levelNumber__auO6e","gold":"style_gold__LkTIJ"};